import Tools from './../components/tools';

export default class Page {
    constructor() {
        // Page

        this.splitText();
        this.scrollBtn();
    }

    splitText() {
        const title = document.querySelector('.header__title');
        const parent = title.parentElement;
        const content = title.innerHTML;
        const currentContent = content.split(' ');

        let myContent = '<span>';
        let spanWidth = 0;

        for(let i = 0; i < currentContent.length;) {
            let newp = document.createElement('span');
            newp.className = 'title title--h2 header__title';
            newp.innerHTML = currentContent[i] + ' ';
            newp.style.display = 'inline-block';
            newp.style.visibility = 'hidden';
            newp.style.whiteSpace = 'nowrap';
            parent.insertBefore(newp, title);

            spanWidth += newp.offsetWidth;

            if(title.clientWidth < spanWidth) {
                myContent += `</span><span>${currentContent[i]} `;
                spanWidth = 0;
            } else {
                myContent += `${currentContent[i]} `;
            }

            newp.remove();

            i += 1;
        }
        myContent += '</span>';
        title.innerHTML = myContent;
    }

    scrollBtn() {
        const btn = document.querySelector('.header__scroll');
        const elt = document.querySelector('.section.introduction');

        if (btn && elt) {
            btn.addEventListener('click', () => {
                window.scrollTo({
                    top: Tools.offset(elt).top - 20,
                    left: 0,
                    behavior: 'smooth',
                });
            });
        }
    }
}